import React, { useEffect } from "react";
import Main from "../main/Main";
import useAuthStore from "../../store/authStore";
import MainShell from "../../components/mainShell";
import { Schedule } from "../public/Schedule";

const StaticLanding: React.FC = () => {
  return <Schedule />;
};

const Landing: React.FC = () => {
  const { authState, verifyToken } = useAuthStore();

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  return (
    <>
      {authState === "valid" ? (
        <MainShell>
          <Main />
        </MainShell>
      ) : (
        <StaticLanding />
      )}
    </>
  );
};

export default Landing;
